import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { SearchBox, GeneralSelect } from 'sharedComponents';
import PropTypes from 'prop-types';
import { filterTabs } from 'helpers/constants';


const FilterComponent = ({ powertrains, selectedPowertrain, activeTab, onPowertrainClick, actions }) => {
    const { t: translate } = useTranslation();
    const {
        searchboxFilter,
        // gatewayTypeFilter
    } = useSelector(({ crossAssetAnalysisSidepanel }) => crossAssetAnalysisSidepanel);

    return activeTab === filterTabs.POWERTRAINS ?
        <GeneralSelect
            options={powertrains}
            getOptionLabel={pt => pt?.name}
            getOptionValue={pt => pt?.powertrainId}
            menuShouldScrollIntoView={false}
            onChange={powertrain => onPowertrainClick(powertrain?.powertrainId)}
            className='powertrain-filter'
            value={selectedPowertrain}
            placeholder={translate('ABB.Powertrain.Frontend.searchPlaceholderNameText')} /> :
        <>
            <SearchBox
                placeholder={translate('ABB.Powertrain.Frontend.searchPlaceholderNameIDSerialNrText')}
                onChange={actions.setSearchboxFilterAction}
                value={searchboxFilter} />
            {/* <GeneralSelect
                options={getGatewayTypeOptions(translate)}
                getOptionLabel={option => option.title}
                getOptionValue={option => option.id}
                defaultValue={getDefaultValue(gatewayTypeFilter, translate)}
                menuShouldScrollIntoView={false}
                onChange={value => actions.setGatewayTypeFilterAction(value.id)}
                className='gateway-type-filter'
                isSearchable={false} /> */}
        </>;
};

export default FilterComponent;

FilterComponent.prototypes = {
    powertrains: PropTypes.array,
    selectedPowertrain: PropTypes.object,
    activeTab: PropTypes.string,
    onPowertrainClick: PropTypes.func,
    actions: PropTypes.object
};
